import Autocomplete from "@/components/panel/Autocomplete";
import usePaginatedList from "@/hooks/usePaginatedList";

/**
 * Escolha de fornecedor com busca no servidor.
 *
 * São milhares de fornecedores: carregar a lista inteira num select não serve,
 * por isso a busca vai ao banco (o `usePaginatedList` já faz o debounce).
 *
 * `selectedLabel` cobre o fornecedor já vinculado que não está na página atual
 * de resultados — sem ele um produto com fornecedor abriria o campo em branco e
 * salvar apagaria o vínculo.
 */
export default function SupplierPicker({
  value,
  onChange,
  selectedLabel,
  placeholder = "Buscar fornecedor...",
  // Vínculo novo não deve oferecer fornecedor desativado; quem precisa da lista
  // completa (filtro de tela, por exemplo) passa `filters={{}}`.
  filters = { situacao: "ativos" },
  testId,
  width = "w-full",
}) {
  const list = usePaginatedList("/admin/suppliers", filters, { perPage: 50 });

  return (
    <Autocomplete
      value={value || ""}
      onChange={onChange}
      options={list.items.map((s) => ({ value: s.id, label: s.name }))}
      query={list.search}
      onQueryChange={list.setSearch}
      selectedLabel={selectedLabel}
      placeholder={placeholder}
      emptyLabel="— Sem fornecedor"
      testId={testId}
      width={width}
    />
  );
}
